import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'antd'
import OtherBrokersQL from 'components/broker/OtherBrokersQL'
import PaginatedArticleList from 'components/shared/PaginatedArticles'
import BrokerTradingTools from 'components/broker/BrokerTradingTools'
import BrokerQuickLinks from 'components/broker/BrokerQuickLinks'

export default function BrokerFAQ({ broker, allBrokers }) {
  const {
    articles: { data: customArticles },
    brokerArticlesCount,
  } = broker

  return (
    <Row
      className="page-wrapper page"
      gutter={[16, 16]}
      style={{ width: '100%', padding: '16px' }}
    >
      <Col xs={24} md={16}>
        <Row className="row-wrapper" style={{ width: '100%' }}>
          {customArticles.length > 0 ? (
            <PaginatedArticleList
              articles={customArticles}
              count={brokerArticlesCount}
              type="broker"
            />
          ) : (
            <h5> No FAQs Found </h5>
          )}
        </Row>
      </Col>
      <Col xs={24} md={8} style={{ marginTop: 16 }}>
        <BrokerQuickLinks broker={broker} />
        <BrokerTradingTools broker={broker} />
        <OtherBrokersQL
          allBrokers={allBrokers}
          currentBroker={broker}
          country={broker.country}
        />
      </Col>
    </Row>
  )
}

BrokerFAQ.propTypes = {
  allBrokers: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
    })
  ).isRequired,
  broker: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    customArticles: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
      }).isRequired
    ).isRequired,
    brokerArticlesCount: PropTypes.number.isRequired,
  }).isRequired,
}
